import { type UseQueryOptions, useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '@/query-client'
import {
	type HttpGetExperienceVettingGalleryImagesOptions,
	type HttpGetExperienceVettingGalleryImagesResponse,
	httpGetExperienceVettingGalleryImages
} from '../http/experience-vetting.http'

export const useGetExperienceVettingGalleryImages = (
	urlParams: HttpGetExperienceVettingGalleryImagesOptions['urlParams'],
	options?: Omit<
		UseQueryOptions<HttpGetExperienceVettingGalleryImagesResponse>,
		'queryKey' | 'queryFn'
	>
) => {
	return useQuery({
		...options,
		queryKey: [
			QUERY_KEYS.EXPERIENCE_VETTING_GALLERY_IMAGES,
			urlParams.experienceId
		],
		queryFn: () =>
			httpGetExperienceVettingGalleryImages({
				urlParams,
				params: { response_type: 'extended' }
			})
	})
}
